<!-- banner  -->
<div class="collab-banner sticky-header-banner banner-sec">
  <div class="container">
      <div class="sec-padding m-col-width mt-negative pb-0">
          <div class="text-center z-index pb-2">

              <div class="mx-auto whats-new-label banner-wts-new-label">
                  <div class="wave-container">
                    <div class="wave-dot wave-dot-1"></div> 
                    <div class="wave-dot wave-dot-3"></div> 
                  </div> 
                  <span class="secondary-gradient-text paragraph-global-text sub-head-paragraph">
                      Contact us
                  </span>
              </div>

              <h1 class="banner-heading secondary-gradient-text mx-auto mw-700">
                {{ "contactUs.contactUsTitle" | translate }}
              </h1>
              <p class="paragraph-global-text text-whitish-gray mw-600">
                {{ "contactUs.contactUsText" | translate }}
              </p>
        
          </div>
      </div>
  </div>
</div>

<div class="sec-padding departments-sec position-relative">
  <div class="container">
    <div class="row mx-0 m-col-width">
      <div class="col-md-4 mt-3 col-sm-12 col-xs-12">
        <div class="dep-card card card-border">
          <div>            
            <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-headset icon-primary-color"><path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"/><path d="M21 16v2a4 4 0 0 1-4 4h-5"/></svg>
           </div>
            <h2 class="heading-three mt-4">{{'contactUs.customerSupport' | translate}}</h2>
            <p class="paragraph-global-text d-block">{{'contactUs.customerSupportDesc' | translate}}</p>
          </div>
          <a class="save-btn mt-4" href="{{websiteUrl}}en/cms/contactus?department=1">{{'contactUs.reachOut' | translate}}</a>
        </div>
      </div>
      <div class="col-md-4 mt-3 col-sm-12 col-xs-12">
        <div class="dep-card card card-border">
          <div>
            <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-messages-square icon-primary-color"><path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"/><path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"/></svg>
           </div>
            <h2 class="heading-three mt-4">{{'contactUs.salesQueiries' | translate}}</h2>
            <p class="paragraph-global-text d-block">{{'contactUs.salesQueiriesDesc' | translate}}</p>
          </div>
          <a class="save-btn mt-4" href="{{websiteUrl}}en/cms/contactus?department=2">{{'contactUs.getInTouch' | translate}}</a>
        </div>
      </div>
      <div class="col-md-4 mt-3 col-sm-12 col-xs-12">
        <div class="dep-card card card-border">
          <div>
            <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-handshake icon-primary-color"><path d="m11 17 2 2a1 1 0 1 0 3-3"/><path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"/><path d="m21 3 1 11h-2"/><path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"/><path d="M3 4h8"/></svg>
            </div>
            <h2 class="heading-three mt-4">{{'contactUs.partnerAndAllience' | translate}}</h2>
            <p class="paragraph-global-text d-block">{{'contactUs.partnerAndAllienceDesc' | translate}}</p>
          </div>
          <a class="save-btn mt-4" href="{{websiteUrl}}en/cms/contactus?department=3">{{'contactUs.writeUs' | translate}}</a>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="sec-padding departments-sec sec-primary-background">
  <div class="container">
    <div class="text-center mb-5">
      <div class="mx-auto whats-new-label">
        <div class="wave-container">
          <div class="wave-dot wave-dot-1"></div> 
          <div class="wave-dot wave-dot-3"></div> 
        </div> 
        <span class="primary-color paragraph-global-text sub-head-paragraph">
          {{'contactUs.ourLoactions' | translate}}
        </span>
       </div>
      <h1 class="heading-one mw-800 mx-auto">{{'contactUs.weAreGrowing' | translate}} {{'contactUs.weAreGrowing2' | translate}} {{'contactUs.weAreGrowing3' | translate}} </h1>
      <p class="paragraph-global-text mx-auto sub-head-paragraph" style="max-width: 485px;">{{'contactUs.rightNow' | translate}}</p>
    </div>
    <div class="row mx-0 m-col-width">
      <div class="col-md-4 mt-3 col-sm-12 col-xs-12">
        <div class="dep-card card card-border">
          <div class="res-button-div">            
            <div class="contact-us-clocks-bg clock1-bg-img"></div>
            <h2 class="heading-three primary-color mb-0 mt-4">Delaware, USA</h2>
            <p class="paragraph-global-text">{{delawareTime}}</p>
            <span class="bule-border"></span>
            <p class="paragraph-global-text d-block">Aumnics Inc. 16192 Coastal Highway, Lewes, DE 19958, United States
              <br> Ph: +1 (571) 474-9968</p>
          </div>
          <p class="paragraph-global-text primary-color fw-500"><a href="https://www.google.com/maps?q=38.765003,-75.2115776" target="_blank">OPEN IN MAPS</a><span><figure><span class="pi pi-arrow-right primary-color ml-3 f-15"></span></figure></span></p>
        </div>
      </div>
      <div class="col-md-4 mt-3 col-sm-12 col-xs-12">
        <div class="dep-card card card-border">
          <div class="res-button-div">
            <div class="contact-us-clocks-bg clock2-bg-img"></div>
            <!-- <img loading="lazy" class="clock" width="80px" height="77px" min-height="80px"
             src="../../assets/images/contact-us/new-jersey-clock.png" alt=""> -->
            <h2 class="heading-three primary-color mb-0 mt-4">Newjersy, USA</h2>
            <p class="paragraph-global-text">{{newJerseyTime}}</p>
            <span class="bule-border"></span>
            <p class="paragraph-global-text d-block">1 Overlook Drive, Mount laurel, NJ 08054, United States <br> Ph: +1 (571) 474-9968</p>
          </div>
          <p class="paragraph-global-text primary-color fw-500"><a href="https://www.google.com/maps?q=39.99916, -74.88179" target="_blank">OPEN IN MAPS</a><span><figure><span class="pi pi-arrow-right primary-color ml-3 f-15"></span></figure></span></p>
        </div>
      </div>
      <div class="col-md-4 mt-3 col-sm-12 col-xs-12">
        <div class="dep-card card card-border">
          <div class="res-button-div">
            <div class="contact-us-clocks-bg clock3-bg-img"></div>
            <!-- <img loading="lazy" class="clock" width="80px" height="77px" src="../../assets/images/contact-us/hyd-clock.png" alt=""> -->
            <h2 class="heading-three primary-color mb-0 mt-4">Hyderabad, India</h2>
            <p class="paragraph-global-text">{{hyderabadTime}}</p>
            <span class="bule-border"></span>
            <p class="paragraph-global-text d-block">5th floor, PSR Prime Tower, beside DLF BUILDING, DLF Cyber City, Indira Nagar, Gachibowli, Hyderabad, Telangana 500032</p>
          </div>
          <p class="paragraph-global-text primary-color fw-500"><a href="https://www.google.com/maps?q=17.44691,78.35442" target="_blank">OPEN IN MAPS</a><span><figure><span class="pi pi-arrow-right primary-color ml-3 f-15"></span></figure></span></p>
        </div>
      </div>
    </div>
  </div>
</div>
